import C from "../util/net.js";
import e from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import t from "../common/event-logger.js";
import { newInAppMessageFromJson as pt } from "./in-app-message-factory.js";
import { randomInclusive as U } from "../util/math.js";
import s from "../models/request-result.js";
import { logger as r, EventTypes as i } from "../../shared-lib/index.js";
import T from "../managers/subscription-manager.js";
import gt from "../triggers/models/trigger.js";
import { BRAZE_ACTION_URI_REGEX as Z } from "../util/validation-utils.js";
import {
  containsPushPrimerBrazeAction as ft,
  containsUnknownBrazeAction as jt,
  getDecodedBrazeAction as W,
  ineligibleBrazeActionURLErrorMessage as vt,
  INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as bt,
} from "../util/braze-actions.js";
import yt from "../Push/utils/push-utils.js";
import D from "../util/request-header-utils.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import { FullScreenMessage, ModalMessage, SlideUpMessage } from "./index.js";
export default class aa {
  constructor(t, s, i, r) {
    (this.$t = t),
      (this.oi = s),
      (this.u = i),
      (this.yt = r),
      (this.$t = t),
      (this.oi = s),
      (this.u = i),
      (this.yt = r),
      (this._e = new T()),
      e.Ht(this._e),
      (this.Xe = 1e3),
      (this.We = 6e4),
      (this.Ye = null);
  }
  Ze() {
    return this._e;
  }
  Mi(t) {
    return this._e.Nt(t);
  }
  _i() {
    return this.Ye;
  }
  Pi(t) {
    this.Ye = t;
  }
  q(e, n, o, a) {
    const l = new s();
    let u;
    if (e instanceof ControlMessage) u = { trigger_ids: [e.triggerId] };
    else {
      if (n === i.$i || (e instanceof HtmlMessage && n === i.Oi)) {
        if (!e.p(a))
          return (
            r.info(
              "This in-app message has already received a click. Ignoring analytics event.",
            ),
            l
          );
      } else if (n === i.Xi) {
        if (!e.K())
          return (
            r.info(
              "This in-app message has already received an impression. Ignoring analytics event.",
            ),
            l
          );
      }
      u = this.Hi(e);
    }
    return null == u
      ? l
      : (e.messageExtras && (u.message_extras = e.messageExtras),
        null != o && (u.bid = o),
        t.q(n, u));
  }
  Ji(e, n) {
    const o = new s();
    if (!e.p())
      return (
        r.info(
          "This in-app message button has already received a click. Ignoring analytics event.",
        ),
        o
      );
    const a = this.Hi(n);
    return null == a
      ? o
      : e.id === InAppMessageButton.Ki
      ? (r.info(
          "This in-app message button does not have a tracking id. Not logging event to Braze servers.",
        ),
        o)
      : (null != e.id && (a.bid = e.id), t.q(i.Oi, a));
  }
  Li(t) {
    const e = t.messageFields;
    return (null != e && e.is_push_primer) || !1;
  }
  Qi(t) {
    if (!(t instanceof InAppMessage)) return;
    const e = (t) => {
      if (!t) return;
      const e = W(t);
      return jt(e)
        ? vt(bt.Vi, "In-App Message")
        : ft(e) && !yt.Wi()
        ? vt(bt.Yi, "In-App Message")
        : void 0;
    };
    if (this.Li(t) && !yt.Wi())
      return "In-App Message contains a push prompt, but is not eligible for a push prompt. Ignoring.";
    const s = t.buttons || [];
    let i;
    for (const t of s)
      if (
        t.clickAction === InAppMessage.ClickAction.URI &&
        t.uri &&
        Z.test(t.uri) &&
        ((i = e(t.uri)), i)
      )
        return i;
    return t.clickAction === InAppMessage.ClickAction.URI &&
      t.uri &&
      Z.test(t.uri)
      ? e(t.uri)
      : void 0;
  }
  Zi(t, e, s, i) {
    const n = this.$t;
    if (!n) return;
    const o = n.Ir(!1, !1),
      a = n.$s(o);
    (a.template = { trigger_id: t.triggerId, trigger_event_type: e }),
      null != s && (a.template.data = s.Mr());
    const l = n.Ps(a, D._s.Tr);
    n.Gs(
      a,
      (n = -1) => {
        if (!this.$t) return;
        const o = new Date().valueOf();
        D.Hs(this.u, D._s.Tr, o),
          -1 !== n && l.push(["X-Braze-Req-Tokens-Remaining", n.toString()]),
          C.Ks({
            url: `${this.$t.Os()}/template/`,
            data: a,
            headers: l,
            L: (e) => {
              if ((D.Ws(this.u, D._s.Tr, 1), !this.$t.Qs(a, e, l)))
                return void ("function" == typeof t.Br && t.Br());
              if ((this.$t.Vs(), null == e || null == e.templated_message))
                return;
              const s = e.templated_message;
              if (s.type !== gt.Er._r) return;
              const i = pt(s.data);
              if (null == i) return;
              const n = this.Qi(i);
              if (n)
                return r.error(n), void ("function" == typeof t.Br && t.Br());
              "function" == typeof t.Gr && t.Gr(i);
            },
            error: (r) => {
              let n = `getting user personalization for message ${t.triggerId}`;
              if (new Date().valueOf() - t.Nr < t.Or) {
                D.ti(this.u, D._s.Tr);
                const r = Math.min(t.Or, this.We),
                  o = this.Xe;
                null == i && (i = o);
                const a = Math.min(r, U(o, 3 * i));
                (n += `. Retrying in ${a} ms`),
                  setTimeout(() => {
                    this.Zi(t, e, s, a);
                  }, a);
              }
              this.$t.Ys(r, n);
            },
          });
      },
      D._s.Tr,
    );
  }
  Hi(t) {
    if (null == t.triggerId)
      return (
        r.info(
          "The in-app message has no analytics id. Not logging event to Braze servers.",
        ),
        null
      );
    const e = {};
    return null != t.triggerId && (e.trigger_ids = [t.triggerId]), e;
  }
  je(t) {
    return (
      !!this.u &&
      !(
        !(t && t instanceof InAppMessage && t.constructor !== InAppMessage) ||
        t instanceof ControlMessage
      ) &&
      this.u.I(o.C.Xr, t.Y())
    );
  }
  Se() {
    if (!this.u) return null;
    const t = this.u.j(o.C.Xr);
    if (!t) return null;
    let e;
    switch (t.type) {
      case InAppMessage.Be.Hr:
        e = FullScreenMessage.Jr(t);
        break;
      case InAppMessage.Be.Kr:
      case InAppMessage.Be.Me:
      case InAppMessage.Be.Ve:
        e = HtmlMessage.Jr(t);
        break;
      case InAppMessage.Be.Lr:
      case InAppMessage.Be.Ue:
        e = ModalMessage.Jr(t);
        break;
      case InAppMessage.Be.Qr:
        e = SlideUpMessage.Jr(t);
    }
    return e && this.Ur(), e;
  }
  Ur() {
    this.u && this.u.ii(o.C.Xr);
  }
}
